<template>
    <li @click="$emit('click')" class="ride uk-container uk-container-large">
        <div class="card">
            <div class="left" :style="'background: ' + ride.status.color" />
            <div class="icon">
                <i class="fal fa-truck-moving"></i>
                <p>{{ ride.id }}</p>
            </div>
            <div class="middle">
                <div class="top">
                    <h3 class="time">
                        {{ rideTimeString }}
                    </h3>
                    <p class="vehicle uk-text-truncate">{{ vehicleName }}</p>
                    <span class="delivery uk-text-truncate">({{ ride.items.length }} Leveringen)</span>
                </div>
                <div class="location">
                    <span class="city">
                        {{ locationsString }}
                    </span>
                </div>
            </div>
            <div class="right" :style="'color: ' + ride.status.color">
                <p class="uk-text-truncate">{{ ride.status.description }}</p>
            </div>
        </div>
    </li>
</template>

<style scoped lang="scss">

.ride {
    .card {
        display:               grid;
        grid-template-columns: 15px auto 1fr auto;
        width:                 100%;
        height:                100px;
        align-items:           center;
        border-radius:         5px;
        background-color:      var(--item-background);
        border-bottom:         1px solid var(--item-background);

        .left {
            border-radius: 5px 0 0 5px;
        }
        .icon {
            margin:     5px 10px 0 0;
            text-align: center;

            p {
                margin:    0;
                font-size: 16px;
                color:     var(--dynamic-title-gray-color);
            }
            i {
                font-size: 28px;
                color:     var(--dynamic-title-color);
            }
        }
        .middle {
            display: block;

            .top {
                display:     flex;
                align-items: center;
                gap:         5px;

                h3,
                p,
                span {
                    color: var(--dynamic-title-color);
                }
                p {
                    margin:    0;
                    font-size: 18px;
                }
                h3 {
                    font-weight: 600;
                    margin:      0;
                    text-align:  left;
                }
                span {
                    font-size:     18px;
                    overflow:      hidden;
                    text-overflow: ellipsis;
                    white-space:   nowrap;
                }
                .vehicle {
                    flex:       1 1 0;
                    min-width:  0;
                    text-align: center;
                }
                .delivery {
                    flex:       1 1 0;
                    min-width:  0;
                    text-align: center;
                }
                .time {
                    margin-right: 10px;
                    width:        60px;
                    text-align:   center;
                }
            }
            .location {
                overflow: hidden;

                span {
                    font-size: 16px;
                    color:     var(--dynamic-title-lightGray-color);
                }
            }
        }
        .right {

            p {
                font-size:  22px;
                margin:     0 20px 0;
                text-align: right;
            }
        }
    }
}
.status-geladen {
    background: $theme-blue;
}
.status-geladen-text p {
    color: $theme-blue;
}
.status-completed {
    background: $completed !important;
}
.status-completed-text p {
    color: #2DCE98 !important;
}
.status-disabled {
    background: #cacaca;
}
.status-disabled-text p,
.status-disabled-text span,
.status-disabled-text h3 {
    color: #cacaca !important;
}
</style>

<script>
export default {
    name: "RideView",

    props: {
        ride: {
            type:     Object,
            required: true
        },
    },
    computed: {
        vehicleName: function () {
            return this.ride.vehicle !== null
                ? this.ride.vehicle.name
                : ''
            ;
        },
        pickUpLocations: function () {
            let pickUpPlaces = [];
            this.ride.items.forEach((item) => {
                if (item.packingSlip
                    && item.packingSlip.pickUpAddress
                    && item.packingSlip.pickUpAddress.city
                    && ! pickUpPlaces.includes(item.packingSlip.pickUpAddress)
                ) {
                    pickUpPlaces.push(item.packingSlip.pickUpAddress.city);
                }
            });
            return pickUpPlaces;
        },
        deliveryLocations: function () {
            let deliveryPlaces = [];
            this.ride.items.forEach((item) => {
                if (item.packingSlip !== null) {
                    if (! deliveryPlaces.includes(item.packingSlip.deliveryAddress.city)) {
                        deliveryPlaces.push(item.packingSlip.deliveryAddress.city);
                    }
                }
            },
                deliveryPlaces
            );
            return deliveryPlaces;
        },
        locationsString: function () {
            let string = '';
            [ ... new Set([ ...this.pickUpLocations, ...this.deliveryLocations ])].forEach((location) => {
                if (string) {
                    string += ' | ';
                }
                string += location;
            });
            return string;
        },
        rideTimeString() {
            return (this.ride.departureTime || '--:--') + ' ' + (this.ride.endTime || '--:--');
        }
    },
    methods: {
        /**
         * @param {string} city
         * @param {number} idx
         * @param {number} total
         *
         * @return {string}
         */
        getCityString(city, idx, total) {
            return idx + 1 < total
                ? city + ' | '
                : city
            ;
        },
    }
};
</script>
